import { createSlice } from "@reduxjs/toolkit";

import { createApiThunk, updateState } from "./utilityFunction"

// Initial State
const initialState = {
    fetchAbout: {
        loading: false,
        success: false,
        error: false,
        message: null,
        data: null,
    },
    saveAbout: {
        loading: false,
        success: false,
        error: false,
        message: null,
        data: null,
    },
};

// Async Thunk for Fetching Setting Data
export const fetchAboutData = createApiThunk("about", "fetch")
export const saveAboutData = createApiThunk("about", "save")

// Slice
const aboutSlice = createSlice({
    name: "about",
    initialState,

    reducers: {
        resetAboutState: (state, action) => {
            const type = action.payload; // Assuming the type is passed in the action's payload

            if (type === "fetch") {
                state.fetchAbout = {
                    ...state.fetchAbout, // Preserve existing data
                    loading: false,
                    success: false,
                    error: false,
                    message: null,
                };
            } else if (type === "save") {
                state.saveAbout = {
                    ...state.saveAbout, // Preserve existing data
                    loading: false,
                    success: false,
                    error: false,
                    message: null,
                };
            }
        },
    },

    extraReducers: (builder) => {
        builder
            .addCase(fetchAboutData.pending, (state) => updateState(state, "pending", "fetchAbout"))
            .addCase(fetchAboutData.fulfilled, (state, action) =>
                updateState(state, "fulfilled", "fetchAbout", action.payload.data))
            .addCase(fetchAboutData.rejected, (state, action) =>
                updateState(state, "rejected", "fetchAbout", action.payload))
            // Save data
            .addCase(saveAboutData.pending, (state) => updateState(state, "pending", "saveAbout"))
            .addCase(saveAboutData.fulfilled, (state, action) =>
                updateState(state, "fulfilled", "saveAbout", action.payload.data))
            .addCase(saveAboutData.rejected, (state, action) =>
                updateState(state, "rejected", "saveAbout", action.payload));
    },
});

export const { resetAboutState } = aboutSlice.actions;
export default aboutSlice.reducer;
